import _classCallCheck from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";

var LentiVista = /*#__PURE__*/function (_Vue) {
  _inherits(LentiVista, _Vue);

  var _super = _createSuper(LentiVista);

  function LentiVista() {
    _classCallCheck(this, LentiVista);

    return _super.apply(this, arguments);
  }

  _createClass(LentiVista, [{
    key: "note",
    get: function get() {
      return this.$store.state.configurator.note;
    }
  }, {
    key: "lenteVistaSx",
    get: function get() {
      return this.$store.state.configurator.lenteVistaSx;
    }
  }, {
    key: "lenteVistaDx",
    get: function get() {
      return this.$store.state.configurator.lenteVistaDx;
    }
  }, {
    key: "configLentiV",
    get: function get() {
      return this.$store.state.configLentiV;
    }
  }, {
    key: "openConfigLentiV",
    value: function openConfigLentiV(c) {
      this.$store.commit("openCloseConfigLentiV", c);
    }
  }, {
    key: "resetLenses",
    value: function resetLenses() {
      this.$store.commit("resetLentiVista");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
    }
  }]);

  return LentiVista;
}(Vue);

LentiVista = __decorate([Component({
  computed: {
    sferaDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.sferaDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setSferaDx", value);
      }
    },
    sferaSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.sferaSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setSferaSx", value);
      }
    },
    cilindroDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.cilindroDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setCilindroDx", value);
      }
    },
    cilindroSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.cilindroSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setCilindroSx", value);
      }
    },
    asseDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.asseDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAsseDx", value);
      }
    },
    asseSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.asseSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAsseSx", value);
      }
    },
    semiDistDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.semiDistDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setSemiDistDx", value);
      }
    },
    semiDistSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.semiDistSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setSemiDistSx", value);
      }
    },
    altPupDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.altPupDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAltPupDx", value);
      }
    },
    altPupSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.altPupSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAltPupSx", value);
      }
    },
    addDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.addDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAddDx", value);
      }
    },
    addSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.addSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAddSx", value);
      }
    }
  }
})], LentiVista);
export default LentiVista;